import { FetchComplementaryDataResponse } from './types';

export const normalizeComplementaryData = (
  complementaryData: FetchComplementaryDataResponse
): FetchComplementaryDataResponse => ({
  ...complementaryData,
  DocumentIssuerName: complementaryData.DocumentIssuerName?.trim(),
  DocumentNumber: complementaryData.DocumentNumber?.trim(),
});
